import {useMutation} from '@tanstack/react-query';
import {LoginApi} from '../../../apis/LoginApi/LoginApi.ts';
import {CurrentUser} from '../CurrentUser.ts';
import { PostHogService } from '../../../services/posthogService.ts';

export function usePostLoginMutation() {

    return useMutation<CurrentUser, Error, { username: string; password: string }>({
        mutationFn: async ({username, password}) => {
            const result = await LoginApi.login({username, password});
            if (!result) 
                throw new Error('Invalid credentials');
            
            return new CurrentUser(result);
        },
        onSuccess: (currentUser) => {
            localStorage.setItem('currentUser', JSON.stringify(currentUser));
            const distinctId = currentUser.patientID || currentUser.healthcareProfessionalID;
            const userRole = currentUser.patientID ? 'patient' : 'hcp';
            PostHogService.identify(distinctId, {
                display_name: currentUser.displayName,
                language: currentUser.language,
                user_role: userRole,
                environment: import.meta.env.MODE,
            });
            PostHogService.capture('user logged in', {
                user_role: userRole,
                language: currentUser.language,
            });
        },
        onError: (error) => {
            console.error('Login failed:', error.message);
        },
    });
}